export enum ResizeMode {
  fill = 'fill',
  contain = 'contain',
  cover = 'cover',
}
